export default __webpack_public_path__ + "static/media/tab_au.03dfcd5b.png";